<template>
  <div class="whatsapp-float" :class="{ visible: isVisible }">
    <div class="notification-badge">
      <span class="badge-text">💬 Online</span>
    </div>
    <a
        href="https://wa.me/258877782067?text=Ol%C3%A1%2C%20gostaria%20de%20falar%20com%20voc%C3%AAs"
        target="_blank"
        class="whatsapp-button"
        aria-label="Fale conosco pelo WhatsApp"
    >
      <svg class="whatsapp-icon" viewBox="0 0 24 24" fill="currentColor">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.484 3.085"/>
      </svg>
      <div class="button-content">
        <span class="whatsapp-text">Tire suas dúvidas</span>
        <span class="whatsapp-subtext">Resposta rápida!</span>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: "FloatWhatsapp",
  data() {
    return {
      isVisible: false
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      const viewportHeight = window.innerHeight
      this.isVisible = window.scrollY > viewportHeight
    }
  }
}
</script>

<style scoped>
.whatsapp-float {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  opacity: 0;
  transform: translateY(20px);
  transition: all 0.4s ease;
  pointer-events: none;
}

.whatsapp-float.visible {
  opacity: 1;
  transform: translateY(0);
  pointer-events: auto;
}

.notification-badge {
  background: #ff4444;
  color: white;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: bold;
  margin-bottom: 8px;
  animation: bounce 1.5s infinite;
  box-shadow: 0 2px 10px rgba(255, 68, 68, 0.4);
}

.badge-text {
  display: flex;
  align-items: center;
  gap: 4px;
}

.whatsapp-button {
  display: flex;
  align-items: center;
  background: linear-gradient(45deg, #25d366 0%, #128c7e 50%, #25d366 100%);
  background-size: 200% 200%;
  color: white;
  padding: 16px 20px;
  border-radius: 60px;
  text-decoration: none;
  box-shadow: 0 8px 25px rgba(37, 211, 102, 0.4);
  transition: all 0.3s ease;
  font-weight: 600;
  font-size: 15px;
  animation: glow 2s ease-in-out infinite alternate, gradientShift 3s ease infinite;
  border: 2px solid rgba(255, 255, 255, 0.3);
  position: relative;
  overflow: hidden;
}

.whatsapp-button::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(45deg, transparent, rgba(255, 255, 255, 0.1), transparent);
  transform: rotate(45deg);
  animation: shine 3s infinite;
}

.whatsapp-button:hover {
  transform: translateY(-3px) scale(1.05);
  box-shadow: 0 12px 35px rgba(37, 211, 102, 0.6);
  animation: none;
}

.whatsapp-icon {
  width: 28px;
  height: 28px;
  margin-right: 12px;
  filter: drop-shadow(0 0 5px rgba(255, 255, 255, 0.5));
}

.button-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.whatsapp-text {
  white-space: nowrap;
  font-size: 15px;
  font-weight: 700;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.whatsapp-subtext {
  font-size: 11px;
  opacity: 0.9;
  font-weight: 400;
  margin-top: 1px;
}

@keyframes glow {
  0% {
    box-shadow: 0 8px 25px rgba(37, 211, 102, 0.4);
  }
  100% {
    box-shadow: 0 8px 35px rgba(37, 211, 102, 0.8);
  }
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-8px);
  }
  60% {
    transform: translateY(-4px);
  }
}

@keyframes gradientShift {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes shine {
  0% {
    transform: translateX(-100%) translateY(-100%) rotate(45deg);
  }
  50% {
    transform: translateX(100%) translateY(100%) rotate(45deg);
  }
  100% {
    transform: translateX(-100%) translateY(-100%) rotate(45deg);
  }
}

@media (max-width: 768px) {
  .whatsapp-float {
    bottom: 15px;
    right: 15px;
  }

  .whatsapp-button {
    padding: 14px 18px;
    font-size: 14px;
  }

  .button-content {
    display: none;
  }

  .whatsapp-icon {
    margin-right: 0;
    width: 26px;
    height: 26px;
  }

  .notification-badge {
    margin-bottom: 6px;
  }
}
</style>